module.exports = __webpack_public_path__ + "img/Weapon_14.cd91a1b6.png";